
import { getDb } from '../db/db';
import { StockLocation, StockLocationType } from '../../types';
import { v4 as uuidv4 } from 'uuid';

export const stockLocationRepository = {
    async get(id: string): Promise<StockLocation | undefined> {
        const db = await getDb();
        return db.get('stock_locations_v1', id);
    },

    async list(organizationId: string): Promise<StockLocation[]> {
        const db = await getDb();
        // Assuming single user mode usually filters by org manually or we just get all
        // Since current DB doesn't have org index on locations, we filter in memory
        const all = await db.getAll('stock_locations_v1');
        return all.filter(l => l.organizationId === organizationId);
    },

    async findByType(type: StockLocationType, organizationId: string): Promise<StockLocation[]> {
        const db = await getDb();
        const all = await db.getAllFromIndex('stock_locations_v1', 'by-type', type);
        return all.filter(l => l.organizationId === organizationId);
    },

    async findByVehicleId(vehicleId: string): Promise<StockLocation | undefined> {
        const db = await getDb();
        const results = await db.getAllFromIndex('stock_locations_v1', 'by-vehicle', vehicleId);
        return results[0]; // Should be unique ideally
    },

    async findByFuelCardId(fuelCardId: string): Promise<StockLocation | undefined> {
        const db = await getDb();
        const results = await db.getAllFromIndex('stock_locations_v1', 'by-fuelCard', fuelCardId);
        return results[0];
    },

    async save(location: StockLocation): Promise<void> {
        const db = await getDb();
        await db.put('stock_locations_v1', location);
    },

    async create(data: Omit<StockLocation, 'id'>): Promise<StockLocation> {
        const location: StockLocation = {
            ...data,
            id: uuidv4(),
        };
        await this.save(location);
        return location;
    }
};
